export const homeDefaults = {
  hero_image: "",
  ticker: { enabled: false, speed: 30, items: ["", "", "", ""] },
  hero_eyebrow: "Victoria's Premier Poker League",
  hero_title_line1: "Play. Climb.",
  hero_title_line2: "Become a Legend.",
  hero_subtitle:
    "Compete in tournaments at Victoria's best venues, earn points across the season, and qualify for the Legends Championship Main Event.",
  stats: [
    { n: "3", l: "Home Venues" },
    { n: "$50K", l: "Main Event Pool" },
    { n: "100+", l: "Active Legends" },
    { n: "Weekly", l: "Tournaments" },
  ],
  cta: [
    { title: "Track Your Standing", desc: "Live leaderboards across every venue and season." },
    { title: "Find a Game", desc: "Weekly tournaments at venues across Victoria." },
    { title: "Qualify for Finals", desc: "Earn points and play for the Legends trophy." },
  ],
};
